import type { MentionValue } from './MentionTextField';

export interface MentionQuery {
    start: number;
    end: number;
    query: string;
}

export const getMentionQuery = (value: string, caret: number): MentionQuery | null => {
    const beforeCaret = value.slice(0, caret);
    const mentionStart = beforeCaret.lastIndexOf('@');

    if (mentionStart < 0) {
        return null;
    }

    const query = beforeCaret.slice(mentionStart + 1);
    if (/\s/.test(query)) {
        return null;
    }

    return { start: mentionStart, end: caret, query };
};

export const getAtomicMentionRange = (
    value: string,
    mentions: MentionValue[],
    selectionStart: number,
    selectionEnd: number,
): { start: number; end: number } | null => {
    if (selectionStart !== selectionEnd) {
        return null;
    }

    for (const mention of mentions) {
        const token = `@${mention.displayName}`;
        let tokenStart = value.indexOf(token);
        while (tokenStart >= 0) {
            const tokenEnd = tokenStart + token.length;
            if (selectionStart >= tokenStart && selectionStart <= tokenEnd) {
                return { start: tokenStart, end: tokenEnd };
            }
            tokenStart = value.indexOf(token, tokenEnd);
        }
    }

    return null;
};

export const getNextMentionCandidateIndex = (
    currentIndex: number,
    candidateCount: number,
    direction: 'next' | 'previous',
): number => {
    if (candidateCount === 0) {
        return 0;
    }

    return direction === 'next'
        ? (currentIndex + 1) % candidateCount
        : (currentIndex - 1 + candidateCount) % candidateCount;
};